<template>
  <g-page-wrapper>
    <template slot="pageTitle">
      <g-page-title :title="$t('pages_notice_list.page_title')"  ></g-page-title>
    </template>
    <g-contents>
      <div class="-p-5">
        <div class="-wrapper-between -mb-3" >
          <div class="-wrapper-stretch">
            <template v-if="userInfo.auth === AUTH_GROUP.BespinAdmin">
              <g-button variant="primary" @click="onClickNoticeCreate" id="notice-list-create-button">
                <g-icon name="add"></g-icon>
                <span>{{$t('pages_notice_list.create_button')}}</span>
              </g-button>
            </template>
          </div>
        </div>
        <div class="-tile-container -bg-white">
          <div class="-wrapper">
            <div class="dropDown-wrap custom-select">
              <g-dropdown
                style="padding: 10px"
                id="dashboard-payment-chart-select-month"
                v-model="category"
                @change="changeNotices"
                text-class="-mx-0 -pr-0 -pl-2">
                <g-dropdown-item-wrap class="-width-100 -bg-white -box-shadow-level-4">
                  <g-dropdown-item value="" text="" :text="$t('pages_notice_list.all')"></g-dropdown-item>
                  <g-dropdown-item value="title" text="" :text="$t('pages_notice_list.title')"></g-dropdown-item>
                  <g-dropdown-item value="creatorId" text="" :text="$t('pages_notice_list.creatorId')"></g-dropdown-item>
                </g-dropdown-item-wrap>
              </g-dropdown>
            </div>
            <g-search-bar
              style="width: 60%;"
              no-border
              placeholder="Search anything"
              id="notice-list-search-text"
              v-model="searchText" />
          </div>

          <ag-grid-vue
            id="notice-list-notice-grid"
            style="height: 650px;"
            class="ag-theme-balham"
            row-height="30"
            header-height="30"
            :defaultColDef="defaultColDef"
            :columnDefs="columnDefs"
            :gridOptions="gridOptions"
            :rowData="notices"
            :overlayLoadingTemplate="overlayLoadingTemplate"
            :loadingOverlayComponent="loadingOverlayComponent"
            :overlayNoRowsTemplate="overlayNoRowsTemplate"
            :noRowsOverlayComponent="noRowsOverlayComponent"
            :frameworkComponents="frameworkComponents"
            :modules="modules"
            :paginationPageSize="paging.size"
            :pagination="true"
            :suppressPaginationPanel="true"
            :suppressScrollOnNewData="true"
            @row-data-changed="onRowDataChanged"
            @pagination-changed="paginationChanged"
            @row-clicked="selectNoticeDetail"
            @grid-ready="onGridReady">
          </ag-grid-vue>
          <g-pagenation
            id="notice-list-paging"
            class="-py-6 -pr-2"
            :page-no="paging.pageNo"
            :page-size-list="pageSizeList"
            :page-size="paging.size"
            :total-count="paging.totalCount"
            @change-page-no="onChangePageNo"
            @change-page-size="onChangePageSize"/>
        </div>
      </div>
    </g-contents>
  </g-page-wrapper>
</template>

<script>
import { AgGridVue } from 'ag-grid-vue';
import AgGridMixin from "@/pages/mixin/AgGrid.mixin";
import {AUTH_GROUP, DEFAULT_OPTION_PER_PAGE, DEFAULT_PAGE_SIZE} from "@/constants/constants";
import { mapActions, mapGetters } from 'vuex';
  export default {
    name: 'notice-list',
    componentName: 'NoticeList',
    components: {AgGridVue},
    mixins: [AgGridMixin()],
    data () {
      return {
        searchText: '',
        pageSizeList: DEFAULT_OPTION_PER_PAGE,
        columnDefs: [],
        category: '',
        paging : {
          pageNo : 1,
          size : DEFAULT_PAGE_SIZE,
          startIndex : 0,
          totalCount : 0
        },
        orderCol: '',
        desc: false,
        paths: [{
          path: '/',
          name: this.$t('pages_notice_list.page_title')
        }],
        AUTH_GROUP : AUTH_GROUP
      }
    },
    computed: {
      ...mapGetters('notice', ['notices', 'selectNotice']),
      ...mapGetters('user', ['userInfo'])
    },
    watch: {
      searchText () {
        this.changeNotices();
      },
      notices () {
        if (this.notices.length > 0) {
          this.gridApi.hideOverlay()
        } else {
          this.gridApi.showNoRowsOverlay()
        }
      }
    },
    methods: {
      ...mapActions('notice', ['getNotices', 'setSelectNotice']),
      onExcel(){
        let params = {
          fileName: 'notices',
          allColumns: true
        }
        this.gridApi.exportDataAsCsv(params);
      },
      onGridReady (params) {
        this.setGridParams(params);
        this.fitGrid();
        this.changeNotices();
        this.rowData = this.notices;
        this.paging.totalCount = this.notices.length
      },
      onChangePageNo (pageNo) {
        this.paging.pageNo = pageNo;
        this.gridApi.paginationGoToPage(pageNo - 1);
      },
      onChangePageSize (pageSize) {
        this.paging.size = pageSize;
        this.paging.pageNo = 1;
        this.gridApi.paginationSetPageSize(this.paging.size);
        this.gridApi.paginationGoToPage(this.paging.pageNo - 1);
        this.fitGrid()
      },
      onRowDataChanged () {
        this.fitGrid()
      },
      onSearch() {
        this.changeNotices()
      },
      selectNoticeDetail(event) {
        this.setSelectNotice({selectNotice: event.data})
        this.$router.push(`/notice/info?id=${this.selectNotice.id}`)
      },
      changeNotices () {
        let payLoad = {
          category: this.category,
          pageNo: this.paging.pageNo,
          searchText: this.searchText,
          orderCol: this.orderCol,
          desc: this.desc
        }
        this.gridApi.showLoadingOverlay()
        this.getNotices(payLoad)
      },
      paginationChanged (e) { // totalcount 업데이트
        this.paging.totalCount = e.api.rowModel.rowsToDisplay.length
      },
      onClickNoticeCreate () {
        this.$router.push(`/notice/create`)
      },
      setColumn () {
        if(this.userInfo.auth === 'PA'){
          this.columnDefs = [
            {
              headerName: "No.",
              field: "no",
              width: 30,
              unSortIcon: true,
              cellStyle : {"cursor":"pointer"},
              minWidth: 80
            },
            {
              headerName: this.$t('pages_notice_list.title'),
              field: "title",
              unSortIcon: true,
              cellStyle : {"cursor":"pointer"}
            },
            {
              headerName: this.$t('pages_notice_list.hit'),
              field: "hit",
              width: 30,
              unSortIcon: true,
              cellStyle : {"cursor":"pointer"},
              minWidth: 100
            },
            {
              headerName: this.$t('pages_notice_list.visible'),
              field: "visible",
              width: 30,
              unSortIcon: true,
              cellStyle : {"cursor":"pointer"},
              minWidth: 100,
              cellRenderer : obj => {
                if(obj.value){
                  return this.$t('pages_notice_list.visible_true')
                } else {
                  return this.$t('pages_notice_list.visible_false')
                }

              }
            },
            {
              headerName: this.$t('pages_notice_list.creatorId'),
              field: "creatorId",
              unSortIcon: true,
              width: 80,
              cellStyle : {"cursor":"pointer"}
            },
            {
              headerName: this.$t('pages_notice_list.created'),
              field: "created",
              unSortIcon: true,
              width: 50,
              cellStyle : {"cursor":"pointer"}
            }
          ]
        }else {
          this.columnDefs = [
            {
              headerName: "No.",
              field: "no",
              width: 30,
              unSortIcon: true,
              cellStyle : {"cursor":"pointer"},
              minWidth: 80
            },
            {
              headerName: this.$t('pages_notice_list.title'),
              field: "title",
              unSortIcon: true,
              cellStyle : {"cursor":"pointer"},
              minWidth: 80
            },
            {
              headerName: this.$t('pages_notice_list.hit'),
              field: "hit",
              width: 30,
              unSortIcon: true,
              cellStyle : {"cursor":"pointer"},
              minWidth: 100
            },
            {
              headerName: this.$t('pages_notice_list.creatorId'),
              field: "creatorId",
              unSortIcon: true,
              width: 80,
              cellStyle : {"cursor":"pointer"}
            },
            {
              headerName: this.$t('pages_notice_list.created'),
              field: "created",
              unSortIcon: true,
              width: 50,
              cellStyle : {"cursor":"pointer"}
            }
          ]
        }

      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/pages/notice/NoticeList.vue